import { useState, useEffect } from "react";
import styled from "styled-components";
import StringToKebab from "../../helpers/StringToKebab";
import Breakpoints from "../../config/Breakpoints";
import StyledButton from "../../atom/Button";

const LuckyNumberPageMenuContainer = styled.div`
    position: sticky;
    top: 0;
    z-index: 1001;
    display: flex;
    gap: 1.5rem;
    align-items: center;
    order: 2;
    padding: 2rem;
    border-bottom: 1px solid var(--color-lightGray);
    background: var(--color-white);

    @media ${Breakpoints.max.sm} {
        display: none;
    }

    & > .mainMenu {
        display: flex;
        align-items: center;
        gap: 1.5rem;
        font-size: var(--font-size-md);
        font-weight: var(--font-weight-bold);
        cursor: pointer;
        flex: 1;
    }
`;

const LuckyNumberPageMenu = ({promoData, openAgreement, openAcceptAgreement, openLuckyNumbers}) => {
    const [sections, setSections] = useState([]);

    useEffect(() => {
        let sectionBuffer = [];
        promoData.pageConfig?.sections?.forEach((section, index) => {
            if(index > 0) {
                sectionBuffer.push({
                    slug: StringToKebab(section.title),
                    title: section.title
                });
            }
        });
        if(sectionBuffer.length > 0) {
            setSections(sectionBuffer);
        }
    },[promoData]);
    
    const scrollToSection = (id) => {
        const sectionElement = document.getElementById(id);
        if(sectionElement) {
            sectionElement.scrollIntoView({behavior: 'smooth'});
        }
    };

    return (
        <>
            {promoData?.pageConfig?.sections?.length > 2 && (
                <LuckyNumberPageMenuContainer>
                    <div className="mainMenu">
                        {sections.map((section, index) => (
                            <span key={`menuitem_${index}`} onClick={() => scrollToSection(section.slug)}>{section.title}</span>
                        ))}
                        {promoData.agreement?.urlDocument && (
                            <span onClick={() => openAgreement()}>Regulamento</span>
                        )}
                    </div>
                    {!promoData.isEnded && (
                        <div className="buttons">
                            {promoData.agreement && promoData.daysToParticipate && !promoData.agreement?.isAccepted && (
                                <StyledButton className="small" style={{borderRadius: ".5rem"}} onClick={() => openAcceptAgreement()}>
                                    Participar
                                </StyledButton>
                            )}
                            {promoData.agreement?.isAccepted && (
                                <StyledButton className="small" style={{borderRadius: ".5rem"}} onClick={() => openLuckyNumbers()}>
                                    Meus números
                                </StyledButton>
                            )}
                        </div>
                    )}
                </LuckyNumberPageMenuContainer>
            )}
        </>
    )
};

export default LuckyNumberPageMenu;